/**
 * Codex Design System — Utility functions
 *
 * Generic helpers with no app-specific dependencies.
 * Import as: `import { formatRelativeTime } from '@codex/utils'`
 */

export * from './timeUtils';
export * from './dateUtils';
export * from './gradientUtil';
export * from './sliceUtils';

/** Alias: relative time (e.g. "2h ago"). Wraps formatTimeAgo. */
export { formatTimeAgo as formatRelativeTime } from './timeUtils';

export function formatEventDate(dateString: string | null | undefined): string {
  if (!dateString) return '';
  try {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  } catch {
    return dateString;
  }
}

export function formatDate(dateString: string | null | undefined): string {
  return formatEventDate(dateString);
}

/** Alias: formatEventDate under a legacy name used by some call sites. */
export function formatEventTime(dateString: string | null | undefined): string {
  return formatEventDate(dateString);
}
